namespace $ { $mol_style_attach( "mol/form/form.view.css",
 "[mol_form] {\r\n\tgap: var(--mol_gap_block);\r\n}\r\n\r\n[mol_form_body] {\r\n\tgap: var(--mol_gap_block);\r\n}"
) }